import React from 'react';
import { getContextIcon } from '../../utils/freakUtils';

/** The context's icon (same icons as the rest of the web app), sized / coloured via sx. */
export const contextIcon = (context, sx = {}) => {
  const icon = getContextIcon(context);
  return React.isValidElement(icon) ? React.cloneElement(icon, { sx: { fontSize: 18, ...sx } }) : null;
};
